import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { badges as Badges } from '@breezeway/brzw-components';
import { taskHelper } from '@common/utils';
import { CLASS_NAME } from './constants';

const { TASK_PRIORITIES } = taskHelper;

const PriorityBadgeManager = ({ priority }) => {
  const { BADGE_SIZES, BADGE_THEMES } = Badges.constants;
  const size = BADGE_SIZES.AUTO;

  const name = _.get(priority, 'name');
  const code = _.get(priority, 'code');
  const text = `${name} Priority`;
  const theme =
    code === TASK_PRIORITIES.HIGH || code === TASK_PRIORITIES.URGENT
      ? BADGE_THEMES.OUTLINE
      : BADGE_THEMES.OUTLINE_GRAY;

  return <Badges.Badge className={CLASS_NAME} size={size} text={text} theme={theme} />;
};

PriorityBadgeManager.propTypes = {
  priority: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
};

PriorityBadgeManager.defaultProps = {
  priority: {},
};

export default PriorityBadgeManager;
